import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { AppMode, AppService } from "../../app.service";

@Component({
  selector: "ba-app-mode-switch",
  templateUrl: "./app-mode-switch.component.html",
  styleUrls: ["./app-mode-switch.component.css"],
})
export class AppModeSwitchComponent implements OnInit, OnDestroy {
  activeMode: AppMode = "REPORTING";
  switching = false;

  private modeSubscription: Subscription;

  constructor(private appService: AppService) {}

  ngOnInit(): void {
    this.modeSubscription = this.appService.appMode$.subscribe((mode) => {
      this.activeMode = mode;
    });
  }

  ngOnDestroy(): void {
    if (this.modeSubscription) {
      this.modeSubscription.unsubscribe();
    }
  }

  selectMode(mode: AppMode): void {
    if (this.switching || mode === this.activeMode) {
      return;
    }

    this.switching = true;
    this.appService.switchAppMode(mode).subscribe((switched) => {
      this.switching = false;

      if (!switched) {
        this.appService.router.navigate(["/login"]);
      }
    });
  }
}
